import { atom } from 'jotai';

export const isSidebarOpenAtom = atom<boolean>(false);

export const isForceUpdatingAtom = atom<boolean>(false);

export const loadingAtom = atom<boolean>(false);
